import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    console.log("constantdatadum -environmental", data);
    fields = {
      landing: data?.landing?.map((data: ModuleFields[])=>{
                return mapFields(data);
        }),
    };
    console.log("constantsdum-maincontent", fields);
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
